<div style="margin: 20px">
  <app-add-customer
    [merchantId]="merchantId"
    [customer]="customer"
    [mode]="mode"
    (newCustomer)="handleCustomerSaved($event)"
  ></app-add-customer>
</div>
